
import { call, put, takeEvery } from "redux-saga/effects"

import {
    GET_SYSTEM_USERS,
    ADD_NEW_SYSTEM_USER,
    DELETE_SYSTEM_USER,
    UPDATE_SYSTEM_USER,
} from "./actionTypes"

import {
    getSystemUsersSuccess,
    getSystemUsersFail,
    addNewSystemUserSuccess,
    addNewSystemUserFail,
    updateSystemUserSuccess,
    updateSystemUserFail,
    deleteSystemUserSuccess,
    deleteSystemUserFail,
} from "./actions"

import {
    getSystemUsers,
    addNewSystemUser,
    updateSystemUser,
    deleteSystemUser,
} from "../../helpers/fakebackend_helper"

function* fetchSystemUsers() {
    try {
        const response = yield call(getSystemUsers)
        yield put(getSystemUsersSuccess(response))
    } catch (error) {
        yield put(getSystemUsersFail(error))
    }
}

function* onAddNewSystemUser({ payload: user }) {
    try {
        const response = yield call(addNewSystemUser, user)
        yield put(addNewSystemUserSuccess(response))
    } catch (error) {
        yield put(addNewSystemUserFail(error))
    }
}

function* onUpdateSystemUser({ payload: user }) {
    try {
        const response = yield call(updateSystemUser, user)
        yield put(updateSystemUserSuccess(response))
    } catch (error) {
        yield put(updateSystemUserFail(error))
    }
}

function* onDeleteSystemUser({ payload: id }) {
    try {
        yield call(deleteSystemUser, id)
        yield put(deleteSystemUserSuccess(id))
    } catch (error) {
        yield put(deleteSystemUserFail(error))
    }
}

function* systemUsersSaga() {
    yield takeEvery(GET_SYSTEM_USERS, fetchSystemUsers)
    yield takeEvery(ADD_NEW_SYSTEM_USER, onAddNewSystemUser)
    yield takeEvery(UPDATE_SYSTEM_USER, onUpdateSystemUser)
    yield takeEvery(DELETE_SYSTEM_USER, onDeleteSystemUser)
}

export default systemUsersSaga
